import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiQuery } from '../../../../common/model/api.query';
import { users } from '../model/user.fragments';
import { UserOutput } from '../model/user.output';

export interface FetchUsersByIdsParams {
	readonly ids: string[];
}

@Injectable({ providedIn: 'root' })
export class FetchUsersByIdsApiQuery extends ApiQuery<
	UserOutput[],
	FetchUsersByIdsParams
> {
	client = 'iam';
	document = gql`
		query FetchUsersByIds($ids: [UUID]!) {
			fetchUsersByIds(ids: $ids) {
				...Users
			}
		}
		${users}
	`;
	method = 'fetchUsersByIds';
}
